import { lazy, Suspense } from "react";

// Defers recharts+d3 (~2MB raw) into an async chunk. AsideStats renders a
// recharts BarChart in a ResponsiveContainer (client-sized), so the null
// fallback during SSR + load after hydration is not a regression. Named export
// is mapped to a default for React.lazy.
const AsideStatsImpl = lazy(() =>
  import("./AsideStats.impl").then((m) => ({ default: m.AsideStats }))
);

export const AsideStats = (props) => (
  <Suspense fallback={null}>
    <AsideStatsImpl {...props} />
  </Suspense>
);
